import { z } from 'zod'

export const ConfigurationMilestoneZod = z.object({
  enabled: z.boolean().optional().default(false),
})
